import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../../core/services/event.service';
import { concat } from 'rxjs';

@Component({
  selector: 'app-expense-approval-modal',
  templateUrl: './expense-approval-modal.component.html',
  styleUrls: ['./expense-approval-modal.component.css'],
})
export class ExpenseApprovalModalComponent implements OnInit {
  @Input() data: any; //was alldata
  @Input() mode: any;
  @Input() currentPageData: any;
  @Input() single: any;
  portalSettings: any;
  formData: { [key: string]: any } = {};
  allCount: number;
  pageCount: number;
  submitString: string;
  Reviewer: any;
  reviewerList: any;
  ReviewerOnSubmit: boolean;
  isRequestSubmitted: boolean;
  multi: boolean;
  approverList: any;
  reviewerObservables: any = {};

  constructor(
    portalSettingsService: PortalSettingsService,
    private employeeService: EmployeeService,
    public activeModal: NgbActiveModal,
    private eventService: EventService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.formData.Notes = null;
    this.allCount = 0;
    this.pageCount = 0;
    this.submitString = '';
    this.formData.selectedReviewer = {};
    this.Reviewer = [];
    this.reviewerList = [];
    this.ReviewerOnSubmit = this.portalSettings.ReviewerOnSubmit.ConfigValue == '1';
    this.isRequestSubmitted = false;

    if (this.single != null && this.ReviewerOnSubmit) this.GetApprovalHistoryByItem();

    this.data.forEach((val: any) => {
      if (val.Selected) this.allCount++;
    });

    this.currentPageData.forEach((val: any) => {
      if (val.Selected) this.pageCount++;
    });

    if (this.pageCount < this.allCount && this.single == null) this.multi = true;
    else this.multi = false;
  }

  registerObservables() {
    this.reviewerObservables['ReviewerInput$'] = new Subject<any>();
    this.reviewerObservables['Reviewer$'] = concat(
      this.reviewerObservables['ReviewerInput$'].pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(async (term: any) => {
          const result: any = await this.employeeService.getReviewers(this.formData.selectedReviewer.Label);
          return result;
        })
      )
    );
  }

  private GetApprovalHistoryByItem() {
    this.employeeService.getApprovalHistoryByItem(this.single.ReceiptItemID).then((response: any) => {
      this.approverList = response;
    });
  }

  public addReviewer() {
    this.reviewerList.push({ reviewer: this.formData.selectedReviewer.Value, reviewerName: this.formData.selectedReviewer.Label });
    this.formData.selectedReviewer = null;
  }

  public pageClicked(type) {
    this.isRequestSubmitted = true;
    this.submitString = '';
    if (this.single == null) {
      let count = 0;
      this.data.forEach((val: any) => {
        if (val.Selected) {
          this.submitString += val.ReceiptItemID + ',';
          count++;
        }
      });
    } else {
      this.submitString = this.single.ReceiptItemID;
    }
    if (type == 'A' && this.reviewerList.length > 0) {
      this.employeeService.addReviewer(this.reviewerList[0].reviewer.Reviewer, this.submitString, null).then((response: any) => {
        this.employeeService.approveItems(this.submitString, type, this.formData.Notes).then((response2: any) => {
          this.activeModal.close({ status: response2.success, type: type, error: response2.error });
        });
      });
    } else {
      this.employeeService.approveItems(this.submitString, type, this.formData.Notes).then((response: any) => {
        this.activeModal.close({ status: response.success, type: type, error: response.error });
      });
    }
  }

  public cancelClicked() {
    this.activeModal.close();
  }
}
